import { capitalize } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { NonProfitDetailListItem } from '../nonProfitDetailListItem/NonProfitDetailListItem'
import { FlagBadge } from '../flagBadge/FlagBadge'
import { RelationshipBadge } from '../relationshipBadge/RelationshipBadge'
import { SelectedRegistryData } from '../dialogs/registryModal/RegistryModal.types'
import { RelationshipDropdownValues, RelationshipValues } from '../relatedOrganisations/RelatedOrganisations.types'
import { validationOrganisationHasRelationships } from '../utils/validationOrganisationHasRelationships'
import { validationOrganisationIsParent } from '../utils/validationOrganisationIsParent'

import { ListItemButton } from '@percent/admin-dashboard/common/components/listItemButton/ListItemButton'
import { ReactComponent as PencilSVG } from '@percent/admin-dashboard/common/assets/images/pencil.svg'
import { Validation } from '@percent/admin-dashboard/api/actions/admin/admin.types'
import { CreateRegistryProps } from '@percent/admin-dashboard/api/actions/registries/registries.types'

type RegistrySectionProps = {
  registryNameValue: string | undefined | false
  registryIdValue: string | undefined
  registryData: CreateRegistryProps | null
  selectedRegistryData: SelectedRegistryData
  inputsEditable: boolean
  isApproved: boolean
  validation: Validation | undefined
  relatedOrganisations: unknown[] | null
  relationshipFormType?: RelationshipDropdownValues | ''
  registryIdDoesNotMatchRegistryRegex: () => boolean
  setRegistryModalOpened: (open: boolean) => void
}

export function RegistrySection({
  registryNameValue,
  registryIdValue,
  registryData,
  selectedRegistryData,
  inputsEditable,
  isApproved,
  validation,
  relatedOrganisations,
  relationshipFormType,
  registryIdDoesNotMatchRegistryRegex,
  setRegistryModalOpened
}: RegistrySectionProps) {
  const { t } = useTranslation()

  return (
    <>
      <NonProfitDetailListItem title={t('table.registryName')}>
        <span>{registryNameValue}</span>
        {inputsEditable &&
          !selectedRegistryData?.registry.id &&
          selectedRegistryData?.registryInformationNotFound !== true && (
            <FlagBadge variant="warning">{t('typography.registryReviewRequired')}</FlagBadge>
          )}
        {inputsEditable && (
          <ListItemButton
            title={t(`button.editRegistry`)}
            onClick={() => setRegistryModalOpened(true)}
            icon={<PencilSVG />}
            disabled={!validation}
          />
        )}
      </NonProfitDetailListItem>
      {registryData && (
        <NonProfitDetailListItem title={t('table.registryEnglishName')}>
          <span>
            {validation && selectedRegistryData?.registryInformationNotFound
              ? t('typography.notFound')
              : selectedRegistryData?.registry?.englishName && capitalize(selectedRegistryData?.registry?.englishName)}
          </span>
        </NonProfitDetailListItem>
      )}
      <NonProfitDetailListItem title={t('table.registryId')}>
        <span>{registryIdValue}</span>
        {((inputsEditable &&
          !selectedRegistryData?.registry.id &&
          selectedRegistryData?.registryInformationNotFound !== true) ||
          registryIdDoesNotMatchRegistryRegex()) && (
          <FlagBadge variant="warning">{t('typography.registryReviewRequired')}</FlagBadge>
        )}
        {isApproved && validationOrganisationHasRelationships(validation) && (
          <FlagBadge variant="default">
            {t(
              `dialog.relatedOrganisations.badge.${
                validationOrganisationIsParent(validation) ? RelationshipValues.CHILD : RelationshipValues.PARENT
              }`
            )}
          </FlagBadge>
        )}
        {!!relatedOrganisations?.length &&
          (relationshipFormType ? (
            <RelationshipBadge relationshipType={relationshipFormType as RelationshipDropdownValues} />
          ) : (
            <FlagBadge variant="warning">{t('typography.registryIdInUse')}</FlagBadge>
          ))}
      </NonProfitDetailListItem>
    </>
  )
}
